export const INQUIRY_FALLBACK_ERROR =
  "지금은 신청을 접수하지 못했어요. 잠시 후 다시 시도하시거나 contact@hereby.me 로 연락해 주세요.";

function record(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

/** HTTP 상태와 tRPC의 명시적 접수 성공 응답을 모두 확인합니다. */
export async function postInquiry(
  apiBaseUrl: string,
  input: Record<string, string>,
  fetcher: typeof fetch = fetch,
): Promise<void> {
  const res = await fetcher(`${apiBaseUrl.replace(/\/$/, "")}/trpc/inquiry.create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ json: input }),
  });
  const body = record(await res.json().catch(() => null));
  const error = record(body.error);
  if (!res.ok || body.error) {
    const message = record(error.json).message ?? error.message;
    throw new Error(typeof message === "string" && message ? message : INQUIRY_FALLBACK_ERROR);
  }
  const result = record(record(record(body.result).data).json);
  if (result.success !== true) {
    throw new Error(INQUIRY_FALLBACK_ERROR);
  }
}
